import { useQuery } from '@tanstack/react-query';
import { getPrescribers } from '../../../../apis/clinics/requests';
import { User } from '../../../../apis/users';

interface UseGetPrescribersReturn {
  prescribers: User[];
  isLoading: boolean;
}

const useGetPrescribers = (clinicId: string): UseGetPrescribersReturn => {
  const { data, isLoading } = useQuery(
    ['prescribers', clinicId],
    () => getPrescribers(clinicId)
  );

  return {
    prescribers: data?.data || [],
    isLoading
  };
};

export default useGetPrescribers; 